import React, { useContext, useEffect, useReducer, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Nav, Tab } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";

import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import dayjs from "dayjs";
import { getAllVendorApi } from "../../service/vendor/getAllVendors";
import { getPaymentAdviceListApi } from "../../service/bankApi/getPaymentAdviceListApi";
import PaymentAdviceTable from "./PaymentAdviceTable";

function UpdatePayment(props) {
  const { PropertyId, customerId } = useSelector((state) => state.auth);
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const [vendorListArr, setVendorListArr] = useState([]);
   const [apiLoading, setApiLoading] = useState(false);
   const [pageViewVendor, setPageViewVendor] = useState(1);
   const [pageSizeViewVendor, setPageSizeViewVendor] = useState(10);
   const [totalPageViewVendor, setTotalPageViewVendor] = useState(10);
   const [searchValueViewVendor, setSearchValueViewVendor] = useState("");
   const [totalViewVendorCount, setTotalViewVendorCount] = useState(0);
   const [vendorModalView, setVendorModalView] = useState(false);
   const [vendorData, setVendorData] = useState({});
   const { permissions } = useSelector((state) => state.permissionsData);
   const { permissionArr } = useSelector((state) => state.auth);
   const [filterType, setFilterType] = useState(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity");
 
   const [modalType, setModalType] = useState(1);
   const handleSearchViewVendor = (e) => {
     // pageViewVendor(1)
 
     setSearchValueViewVendor(e.target.value);
     if (searchValueViewVendor.trim().length >= 2) {
       onChangePageViewVendor(1);
     }
   };
 
   const handleChangeRowsPerPageViewVendor = (e) => {
     setSearchValueViewVendor("");
     setPageViewVendor(1);
     setPageSizeViewVendor(e.target.value);
   };
 
   const onChangePageViewVendor = (e, p) => {
     // setPage(p);
     setPageViewVendor(e);
   };
 
   const columns = [
    {
      Header: "",
      Footer: "",
      accessor: "hh",
    },
    {
      Header: "PA Number",
      Footer: "PA Number",
      accessor: "PANumber",
    },

    {
      Header: "Total Amount",
      Footer: "Total Amount",
      accessor: "TotalAmount",
    },
    {
      Header: "Amount Recieved",
      Footer: "Amount Recieved",
      accessor: "AmountReceived",
    },
    {
      Header: "Payment Date",
      Footer: "Payment Date",
      accessor: "PaymentDate",
    },
  ];
   useEffect(() => {
     onLoadData();
   }, [pageViewVendor, pageSizeViewVendor]);
 
   function onLoadData(val, val2) {
     let filterType2 = filterType;
     switch (filterType ? filterType : val2) {
       case "Telephone":
         filterType2 = "Type@=Telephone";
         break;
       case "Maintenance/Electricity":
         filterType2 = "Type!@=Telephone";
         break;
       default:
         filterType2 = "Type@=Telephone";
         break;
     }
     setApiLoading(true);
     var data = {
       Filter: `Status==1`,
       OrderBy: "-Id",
       PageSize: pageSizeViewVendor,
       PageNumber: pageViewVendor,
       Keyword: searchValueViewVendor,
     };
     dispatch(
      getPaymentAdviceListApi(
         data,
         (res) => {
           setApiLoading(false);
 
           setVendorListArr(res.data.result.List);
           setTotalViewVendorCount(res.data.result.TotalCount);
           if (
             parseInt(res?.data?.result?.TotalCount) % pageSizeViewVendor ===
             0
           ) {
             setTotalPageViewVendor(
               parseInt(res?.data?.result?.TotalCount / pageSizeViewVendor)
             );
           } else {
             setTotalPageViewVendor(
               parseInt(res?.data?.result?.TotalCount / pageSizeViewVendor + 1)
             );
           }
         },
         (res) => {
           setApiLoading(false);
         }
       )
     );
   }
 
   function handleAddVendorModal(type) {
     setModalType(type);
     setVendorModalView(!vendorModalView);
     if (vendorModalView) {
       onLoadData();
     }
   }
   useEffect(() => {
     let typingTimer;
 
     // Clear the previous typing timer
     clearTimeout(typingTimer);
 
     // Set a new typing timer
     typingTimer = setTimeout(() => {
       onLoadData();
     }, 1500);
 
     // Clean up the timer when component unmounts or search values change
     return () => clearTimeout(typingTimer);
   }, [searchValueViewVendor]);
 
   function handleEditVendor(data) {
  
   }
 
   const [toDate, setToDate] = React.useState(dayjs(new Date()));
   const [fromDate, setFromDate] = React.useState(dayjs(new Date()));
 

  return (
    <>
      <ToastContainer />
      <div
      style={{
        width: "100%",
        border: "1px solid #ccc",
        borderRadius: "5px",
        margin: "0 auto",
        background: "white",
        padding: "20px",
      }}
    >
                                                    <div className="card-body pt-2">
                                                      <PaymentAdviceTable
                                                        column={columns}
                                                        rowsArr={vendorListArr}
                                                        showLoading={apiLoading}
                                                        handleChangeRowsPerPagePagination={
                                                          handleChangeRowsPerPageViewVendor
                                                        }
                                                        setPageSizeViewVendor={setPageSizeViewVendor}
                                                        searchValuePagination={searchValueViewVendor}
                                                        pageSizePagination={pageSizeViewVendor}
                                                        handleSearchPagination={handleSearchViewVendor}
                                                        totalCountPagination={totalPageViewVendor}
                                                        handleOnChangePagination={onChangePageViewVendor}
                                                        totalCount={totalViewVendorCount}
                                                        handleEditVendor={handleEditVendor}
                                                        onLoadData={onLoadData}
                                                        fromDate={fromDate}
                                                        toDate={toDate}
                                                        setFromDate={setFromDate}
                                                        setToDate={setToDate}
                                                        setFilterType={setFilterType}
                                                      />
                                                    </div>
</div>
    </>
  );
}

export default UpdatePayment;
